import React from 'react';
import {
    Card, CardBody, Progress
} from 'reactstrap';
import NotificationSystem from 'react-notification-system';
//react-redux comm
import { connect } from 'react-redux';
import SearchPanel from './pdm-data-panel';

// styling
import './style.css';

import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import {appHelpers, store} from "../../_helpers";
import {apiActions, commonActions} from "../../_actions";




const ViewHeader = () => (
    <div className="view-header d-flex align-items-center">
        <header className="text-white">
            <h1 className="h5 title text-uppercase">PDM DATA ENTRY</h1>
            <p className="mb-0 subtitle text-nowrap">Create Post Departure Manifest</p>
        </header>
    </div>
);

const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class PmdDataEntry extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            contentError:false,
            airlines: [],
            departureAirports: [],
            destinationAirports: []
        }

    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        //    Fetch Airlines
        const reduxState = store.getState();
        if (reduxState.airlinesCarriers) {
            // const localAirlines = reduxState.airlines.Results.filter(item => item.IsLocal);
            this.setState({airlines: this.formatAirlines(reduxState.airlinesCarriers.Results),AirlineId:this.formatAirlines(reduxState.airlinesCarriers.Results).Id});

        } else {
            this.fetchAirlines();
        }


        // Fetch Destination Airports
        if (reduxState.desAirports) {
            this.setState({
                desAirports: this.formatDestinationAirports(reduxState.desAirports.Results)
            });
        } else {
            this.fetchDesAirports();
        }
        // Fetch Departure Airports
        if (reduxState.depAirports) {
            this.setState({
                depAirports: this.formatDepartureAirports(reduxState.depAirports.Results)
            });
        } else {
              this.fetchDepAirports();
        }
    }


    fetchAirlines = () => {
        const {dispatch} = this.props;
        // this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                const { airlinesCarriers } = this.props;
                this.setState({airlines: this.formatAirlines(airlinesCarriers.Results)});
                //this.formatAirlines(res.data.Results);
                dispatch(apiActions.endRequest());
            }).catch(error => {
            // console.log('Error', error);
            let errorMessage = appHelpers.interpretErrorResponse(error);
            // this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
            dispatch(apiActions.endRequest());
        });
    }



    fetchDesAirports = () => {
        const {dispatch} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getDesAirports())
            .then(() => {
                const airports = this.props.desAirports;
                let desAirports = airports.Results;
                desAirports = this.formatDestinationAirports(desAirports);
                this.setState({
                    desAirports
                });
                dispatch(apiActions.endRequest());
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            // this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
            dispatch(apiActions.endRequest());
        });
    }

    fetchDepAirports = () => {
        const {dispatch} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getDepAirports())
            .then(() => {
                const airports = this.props.depAirports;
                //
                let depAirports = airports.Results;
                depAirports = this.formatDepartureAirports(depAirports);
                this.setState({depAirports});
                dispatch(apiActions.endRequest());
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            // this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
            dispatch(apiActions.endRequest());
        });
    }

    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };
    formatDestinationAirports= (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'DestinationAirportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    formatDepartureAirports= (res) => {
        let data = [];
        for (let item of res) {
            item['cat'] = 'DepartureAirportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };



    render() {
        const {requesting, pageRequesting } = this.props;
        const {contentError, airlines, desAirports, depAirports} = this.state

        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }
                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                        <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}

                        { (!contentError && !pageRequesting) &&
                        <CardBody style={{minHeight:'550px'}}>
                            <SearchPanel airlines={airlines} destinationAirports={desAirports} departureAirports={depAirports}/>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        airlinesCarriers: state.airlinesCarriers,
        desAirports: state.desAirports,
        depAirports: state.depAirports,
        requesting: state.api.requesting,
        pageRequesting: state.api.pageRequesting,
        user:state.authentication.user,
    };
}

export default connect(mapStateToProps)(PmdDataEntry);



// WEBPACK FOOTER //
// ./src/views/pdm-data-entry/index.js